import React, { useState, useEffect } from "react";
import Search from "./Search";
import Filter from "./Filter";
import ClearFilters from "./ClearFilters";
import { formatDateFetchJobs } from "../../utils";
import {
  FiltersState,
  handleFilterParamsTypes,
} from "../../types/custom-types";
import {
  DEFAULT_FILTERS_STATE,
  JOBTYPE_OPTIONS,
} from "../../constants/Filters";

interface FiltersProps {
  urlParams: handleFilterParamsTypes;
  activeTab?: string | null;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  setURLParams: (
    obj: {
      startDate?: string | null;
      endDate?: string | null;
      jobTypeFilter?: string | number;
      searchKeyword?: string | null;
    } | null
  ) => void;
}

const Filters: React.FC<FiltersProps> = ({
  urlParams,
  setURLParams,
  activeTab,
  setActiveTab
}) => {
  const [filters, setFilters] = useState<FiltersState>(DEFAULT_FILTERS_STATE);
  const [filterApplied, setFilterApplied] = useState(false);
  const [jobIdProcessed, setJobIdProcessed] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("jobId") && !jobIdProcessed) {
      const searchParam = urlParams.get("jobId");

      setFilters((prev) => ({
        ...prev,
        searchValue: searchParam || "",
      }));
      setURLParams({
        searchKeyword: searchParam,
      });

      urlParams.delete("jobId");
      setJobIdProcessed(true);
    }
  }, [jobIdProcessed]);

  const OPTIONS = [...JOBTYPE_OPTIONS];

  useEffect(() => {
    let isApplied = false;
    for (let key in DEFAULT_FILTERS_STATE) {
      let filterVal = filters[key as keyof FiltersState];
      if (filterVal != null && filterVal != "") {
        isApplied = true;
        break;
      }
    }
    if (isApplied) {
      isFilterApplied(true);
    } else {
      isFilterApplied(false);
    }

    return () => {
      isApplied = false;
    };
  }, [filters]);

  const setSearchValue = (value: string) => {
    setFilters((prev) => ({
      ...prev,
      searchValue: value,
    }));
  };
  const setSelectedOption = (
    option: { value: string | number; label: string } | null
  ) => {
    setFilters((prev) => ({
      ...prev,
      selectedOption: option,
    }));
  };
  const setFromDate = (date: Date | null) => {
    setFilters((prev) => ({
      ...prev,
      fromDate: date,
    }));
  };
  const setToDate = (date: Date | null) => {
    setFilters((prev) => ({
      ...prev,
      toDate: date,
    }));
  };
  const resetAllStates = async () => {
    setFilters(DEFAULT_FILTERS_STATE);
  };

  const isFilterApplied = (applied: boolean = true) => {
    setFilterApplied(applied);
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  const handleChange = (
    option: { value: string | number; label: string } | null
  ) => {
    if (option?.value) {
      setSelectedOption(option);
    } else {
      setSelectedOption(null);
    }
  };

  const handleFromDateChange = (date: Date | null) => {
    setFromDate(date);
  };

  const handleToDateChange = (date: Date | null) => {
    setToDate(date);
  };

  //For search section of filters
  const handleSearchSubmit = () => {
    setURLParams({
      searchKeyword: filters.searchValue,
    });
  };

  //For filter section of filters
  const handleFilterSubmit = () => {
    setURLParams({
      startDate: formatDateFetchJobs(filters.fromDate),
      endDate: formatDateFetchJobs(filters.toDate),
      jobTypeFilter: filters.selectedOption?.value,
    });
  };

  //Clear all filters
  const handleClearAllFilters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    resetAllStates();
    setURLParams({
      startDate: null,
      endDate: null,
      jobTypeFilter: "",
      searchKeyword: "",
    });
    if(urlParams.has('jobId')){
      if(setActiveTab) setActiveTab('Active')
     const url = new URL(window.location.href);
     url.searchParams.delete("jobId");
     window.history.replaceState({}, "", url.pathname + (url.search || "") + url.hash);
    }
    
  };

  return (
    <React.Fragment>
      <Search
        params={urlParams}
        searchValue={filters.searchValue}
        handleSearchChange={handleSearchChange}
        handleSearchSubmit={handleSearchSubmit}
      />
      <Filter
        selectedOption={filters.selectedOption}
        fromDate={filters.fromDate}
        toDate={filters.toDate}
        handleChange={handleChange}
        handleFromDateChange={handleFromDateChange}
        handleToDateChange={handleToDateChange}
        handleFilterSubmit={handleFilterSubmit}
        options={OPTIONS}
      />
      <ClearFilters
        isActive={filterApplied}
        clearAllFilters={handleClearAllFilters}
      />
      {activeTab?.toUpperCase() == "DRAFTS" && (
        <div className="draft-job-info">
          <sup className="note-star">*</sup>Note : Your draft of job will be automatically remove after 60 days from drafts
        </div>
      )}
    </React.Fragment>
  );
};

export default Filters;
